import allenbradleyLogo from "../assets/platform-logos/allenbradley.png";
import csvLogo from "../assets/platform-logos/csv.png";
import automationDirectLogo from "../assets/platform-logos/automation-direct.svg";
import beckhoffLogo from "../assets/platform-logos/beckhoff.png";
import codesysLogo from "../assets/platform-logos/codesys.svg";
import deltaLogo from "../assets/platform-logos/delta.png";
import emersonLogo from "../assets/platform-logos/emerson-logo.png";
import fanucLogo from "../assets/platform-logos/fanuc-logo.png";
import geLogo from "../assets/platform-logos/ge.png";
import ignitionLogo from "../assets/platform-logos/ignition.png";
import kepwareLogo from "../assets/platform-logos/kepware.png";
import koyoLogo from "../assets/platform-logos/koyo.png";
import litmusLogo from "../assets/platform-logos/litmus.png";
import lsElectricLogo from "../assets/platform-logos/ls-electric.svg";
import matrikonLogo from "../assets/platform-logos/matrikon.png";
import mitsubishiLogo from "../assets/platform-logos/mitsubishi.svg";
import mssqlLogo from "../assets/platform-logos/mssql.png";
import omronLogo from "../assets/platform-logos/omron-logo.png";
import opto22Logo from "../assets/platform-logos/opto22.png";
import osisoftLogo from "../assets/platform-logos/osisoft.png";
import panasonicLogo from "../assets/platform-logos/panasonic.svg";
import postgresLogo from "../assets/platform-logos/postgres.png";
import siemensLogo from "../assets/platform-logos/siemens.png";
import toyopucLogo from "../assets/platform-logos/toyoPuc-logo.png";

// Normalize a platform name or connector ID to the canonical lookup key.
// Strips underscores, hyphens, and spaces then lowercases — all LOGO_MAP keys
// must already be in this normalized form, otherwise they are unreachable.
const normalize = (name: string): string => name.toLowerCase().replace(/[\s_-]/g, "");

// Maps normalized connector IDs (and common aliases) to their logo asset URLs.
const LOGO_MAP: Readonly<Record<string, string>> = {
  // Generic / CSV
  genericotmetadata: csvLogo,

  // Litmus Edge
  litmus: litmusLogo,
  litmusedge: litmusLogo,

  // OPC
  kepware: kepwareLogo,
  matrikon: matrikonLogo,
  matrikonopc: matrikonLogo,

  // SCADA / Historian
  ignition: ignitionLogo,
  osisoft: osisoftLogo,
  osisoftpi: osisoftLogo,
  pi: osisoftLogo,

  // Databases
  mssql: mssqlLogo,
  sqlserver: mssqlLogo,
  microsoftsqlserver: mssqlLogo,
  postgres: postgresLogo,
  postgresql: postgresLogo,

  // PLCs
  siemens: siemensLogo,
  allenbradley: allenbradleyLogo,
  rockwellallenbradley: allenbradleyLogo,
  mitsubishi: mitsubishiLogo,
  beckhoff: beckhoffLogo,
  twincat: beckhoffLogo,
  delta: deltaLogo,
  deltaplc: deltaLogo,
  lselectric: lsElectricLogo,
  automationdirect: automationDirectLogo,
  panasonic: panasonicLogo,
  codesys: codesysLogo,
  opto22: opto22Logo,
  koyo: koyoLogo,
  ge: geLogo,
  geproficy: geLogo,
  omron: omronLogo,
  omroncx: omronLogo,
  omronsysmac: omronLogo,
  toyopuc: toyopucLogo,

  // CNC
  fanuc: fanucLogo,
  fanuccnc: fanucLogo,
  fanuccncfocas: fanucLogo,
  siemenscnc: siemensLogo,

  // RTU / Flow computers
  emerson: emersonLogo,
  roclink: emersonLogo,
  roclink800: emersonLogo,
  emersonroclink800: emersonLogo,
};

/**
 * Returns the logo URL for the given connector ID or platform name,
 * or null if no logo is registered.
 */
export function getPlatformLogo(platformId: string): string | null {
  if (!platformId) return null;
  return LOGO_MAP[normalize(platformId)] ?? null;
}
